'use client';
import { Faq } from '@/services/faq.service';
import { Disclosure } from '@headlessui/react';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';
import { FC } from 'react';

const FAQComponent: FC<{ faq: Faq }> = ({ faq }) => {
    return (
        <Disclosure>
            {({ open }) => (
                /* Use the `open` state to conditionally change the direction of an icon. */
                <div
                    className={clsx(
                        'w-full rounded transition-all',
                        open && 'bg-greenApple-default '
                    )}
                >
                    <Disclosure.Button
                        className={clsx(
                            'my-2 flex w-full items-center justify-between gap-4 p-3 font-title sm:p-4',
                            open
                                ? 'text-cyprus-default'
                                : 'sm:hover:text-cyprus-default'
                        )}
                    >
                        <span className="text-left">{faq.question}</span>
                        <ChevronRightIcon
                            className={clsx(
                                'h-6 w-6 shrink-0',
                                open && 'rotate-90 transform'
                            )}
                        />
                    </Disclosure.Button>
                    <Disclosure.Panel
                        className={clsx(
                            'my-2 flex w-full items-center justify-between px-4 font-title leading-relaxed text-neutral-600',
                            open && 'pb-8'
                        )}
                    >
                        {faq.reponse}
                    </Disclosure.Panel>
                </div>
            )}
        </Disclosure>
    );
};

export default FAQComponent;
